import { render, staticRenderFns } from "./hooks.vue?vue&type=template&id=0b0cf844&scoped=true"
import script from "./hooks.vue?vue&type=script&lang=js"
export * from "./hooks.vue?vue&type=script&lang=js"
import style0 from "./hooks.vue?vue&type=style&index=0&id=0b0cf844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0cf844",
  null
  
)

export default component.exports